"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var react_1 = require("@stitches/react");
var react_2 = require("react");
var stitches_config_1 = require("../stitches.config");
var IconButton_1 = require("./IconButton");
var Text_1 = require("./Text");
var FilePickerWrapper = (0, react_1.styled)("label", {
    width: "375px",
    border: "solid",
    borderRadius: "7px",
    borderColor: stitches_config_1.theme.colors.gray7,
    "&:hover": {
        borderColor: stitches_config_1.theme.colors.gray8,
    },
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
        disabled: {
            true: {
                opacity: 0.5,
                cursor: "not-allowed",
            },
        },
    },
});
var StyledButton = (0, react_1.styled)("div", {
    width: "109px",
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    alignItems: "center",
    backgroundColor: stitches_config_1.theme.colors.gray3,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    padding: "4px 6px",
    whiteSpace: "nowrap",
});
var StyledUploader = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "3px",
    cursor: "pointer",
});
var StyledFileName = (0, react_1.styled)("div", {
    marginLeft: "10px",
    color: stitches_config_1.theme.colors.gray11,
    variants: {
        hasValue: {
            true: { color: stitches_config_1.theme.colors.black },
            false: { color: stitches_config_1.theme.colors.gray11 },
        },
    },
    overflow: "hidden",
});
var StyledText = (0, react_1.styled)(Text_1.Text, {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
});
var StyledCrossIcon = (0, react_1.styled)(react_icons_1.Cross2Icon, {
    width: "13px",
    height: "13px",
});
var StyledCrossIconContainer = (0, react_1.styled)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "13px",
    height: "13px",
});
function FilePicker(props) {
    var _a = (0, react_2.useState)(false), loading = _a[0], setLoading = _a[1];
    return ((0, jsx_runtime_1.jsx)(FilePickerWrapper, __assign({ fullWidth: props.fullWidth }, { children: loading ? ((0, jsx_runtime_1.jsx)(Text_1.Text, { children: "Loading..." })) : ((0, jsx_runtime_1.jsxs)(StyledUploader, { children: [(0, jsx_runtime_1.jsxs)(StyledButton, { children: [(0, jsx_runtime_1.jsx)(react_icons_1.UploadIcon, { style: { marginRight: "10px" } }), (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.file ? "Change File" : "Choose File" }))] }), (0, jsx_runtime_1.jsx)("input", { hidden: true, disabled: props.disabled, type: "file", accept: props.accepts ? props.accepts : "application/pdf", onChange: props.handleChange }), (0, jsx_runtime_1.jsx)(StyledFileName, __assign({ hasValue: !!props.file }, { children: (0, jsx_runtime_1.jsx)(StyledText, { children: props.file ? props.file : "No file chosen" }) })), props.file && ((0, jsx_runtime_1.jsx)(IconButton_1.IconButton, __assign({ variant: "ghost" }, { children: (0, jsx_runtime_1.jsx)(StyledCrossIcon, { onClick: function (e) {
                            e.preventDefault();
                            props.handleClear();
                        } }) })))] })) })));
}
exports.FilePicker = FilePicker;
//# sourceMappingURL=FilePicker.js.map